
<template>
  <div>
  <v-card scrollable>
        <v-card-title class="primary" pt0>
          <v-layout>
            <v-flex xs1>
              <h6 class="white--text">Reporte devolución</h6>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-text-field label="Codigo" v-model="codigotabulacion" type="number"
                            dark
                             >
              </v-text-field>
              <v-text-field label="Codigo" v-model="codigotabulacion2" v-if="multitabulacion" type="number"
                            dark
                             >
              </v-text-field>
            </v-flex>
            <v-flex mt-3>
             <v-checkbox
              v-model="multitabulacion"
                  label='multiple' dark
                ></v-checkbox>
               <v-btn  dark  class="print blue darken-4" @click="buscar">
              Buscar</v-btn>
            </v-flex>
            <v-flex mt-3>
               <v-btn  dark  class="print blue darken-4" @click="activo=!activo" v-if="activo">
              Cerrar</v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
                      <v-container>
                        <layout>
                          <v-flex style="overflow-x: auto">
             <table class="table">
              <tr>
                <th></th>
                <th></th>
                <th>Producto</th>
                <th>Total</th>
                <th><v-btn  dark  class="print blue darken-4" v-on:click.native="dialognuevo = true" v-if="codigotabulacion">
              Nuevo</v-btn></th>
                <th></th>
              </tr>
            <tbody>
              <tr v-for="producto in productos">

                <td>
                  <v-btn icon class="green--text text--darken-2" @click="editardevolucion(producto)">
                    <v-icon>check</v-icon>
                  </v-btn></td>
                <td>
                  <v-btn icon class="red--text text--darken-2" @click="producto.activo=!producto.activo">
                    <v-icon>cancel</v-icon>
                  </v-btn></td>

                <td class="text-xs-center">{{producto.producto}}</td>
                <td class="text-xs-center">{{producto.total}}</td>
                <td class="text-xs-center">
                  <v-flex>
                    <v-text-field label="ingreso" v-model="producto.ingreso"
                                  v-if="producto.activo" type="number"
                                   >
                    </v-text-field>
            </v-flex>
                </td>


              </tr>
            </tbody>
          </table>
          </v-flex>
                        </layout>
          </v-container>
        </v-card-text>
        <v-card-action>
          <v-flex mt-3>
               <v-btn  dark  class="print blue darken-4" v-on:click.native="dialogbusqueda = true" v-if="productos">
              Completar</v-btn>
                <v-btn  dark  class="print green darken-4" v-on:click.native="dialogcuadrar = true" v-show="this.$store.getters.gettipo !== 'bodeguero'">
              Cuadrar</v-btn>
             <v-btn  dark  class="print yellow darken-4" v-on:click.native="dialogrevision = true, native=true">
              Revision</v-btn>
            </v-flex>
          <v-dialog v-model="dialogbusqueda" lazy absolute persistent>
            <v-card>
        <v-card-title>
          <div class="headline">Ingrese código del cliente</div>
        </v-card-title>
        <v-card-text>
          <v-text-field label="Codigo" v-model="codigo" @keyup.enter="buscarcliente">
          </v-text-field>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" flat="flat" @click.native="dialogbusqueda = false">Cancelar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="guardardevolucion(codigo)">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
          </v-dialog>
          <v-dialog v-model="dialogcuadrar" lazy absolute persistent>
            <v-card>
        <v-card-text>
          <div class="totales">
            <p>Total A Entregar: {{deuda}}</p>
            <p>Entregado: {{total}}</p>
            <p>Falta: {{faltante}}</p>
          </div>
          <v-text-field label="tabulacion" v-model="codigotabulacion" @keyup.enter="cuadrar" type="number">
          </v-text-field>
          <v-text-field label="tabulacion2" v-model="codigotabulacion2" v-if="multitabulacion"
                        @keyup.enter="cuadrar"
                             >
          </v-text-field>

           <v-btn class="green--text darken-1" flat="flat" @click.native="cuadrar">Buscar</v-btn>

          <v-checkbox
              v-model="multitabulacion"
                  label='multiple'
                ></v-checkbox>
          <div class="content_tabulacion">
            <transition name="slide-fade">
            <div class="tabulacion" @click="activarbilletes" v-bind:class="{progreso: tbilletes}">
             <span>Billetes</span>
            </div>
            </transition>
            <div class="tabulacion" @click="activarmonedas" v-bind:class="{progreso: tmonedas}">
              <span>Monedas</span>
            </div>
            <div class="tabulacion" @click="activarotros" v-bind:class="{progreso: totros}">
              <span>Otros</span>
            </div>
            <div class="tabulacion" @click="activargastos" v-bind:class="{progreso: tgastos}">
             <span>Gastos</span>
            </div>
          </div>
          <div class="detallebilletes" v-if="tbilletes" v-bind:class="{active: tbilletes}">
             <v-text-field label="Q. 200" v-model="b200" type="number" ></v-text-field>
             <v-text-field label="Q. 100" v-model="b100" type="number"></v-text-field>
              <v-text-field label="Q. 50" v-model="b50" type="number"></v-text-field>
              <v-text-field label="Q. 20" v-model="b20" type="number"></v-text-field>
              <v-text-field label="Q. 10" v-model="b10" type="number"></v-text-field>
              <v-text-field label="Q. 5" v-model="b5" type="number"></v-text-field>
              <v-text-field label="Q. 1" v-model="b1" type="number"></v-text-field>
          </div>
          <div class="detallemonedas" v-if="tmonedas" v-bind:class="{active: tmonedas}">
            <v-text-field label="Q.1.00" v-model="m1" type="number"></v-text-field>
              <v-text-field label="Q 0.50" v-model="m50" type="number"></v-text-field>
              <v-text-field label="Q 0.25" v-model="m25" type="number"></v-text-field>
              <v-text-field label="Q 0.10" v-model="m10" type="number"></v-text-field>
              <v-text-field label="Q 0.5" v-model="m5" type="number"></v-text-field>
          </div>

          <div class="detalleotros" v-if="totros" v-bind:class="{active: totros}">
            <v-text-field label="Cheque" v-model="cheque" type="number"></v-text-field>
            <v-text-field label="Depositos" v-model="boleta" type="number"></v-text-field>
            <v-text-field label="No boleta" v-model="no_boleta" type="number"></v-text-field>
            <v-text-field label="No boleta 2" v-model="no_boleta2" type="number"></v-text-field>
            <v-text-field label="No boleta 3" v-model="no_boleta3" type="number"></v-text-field>
            <v-text-field label="observaciones" v-model="observaciones"></v-text-field>
            <v-text-field label="Calificación Compañeros" v-model="calificacion"></v-text-field>
          </div>
          <div class="detallegastos" v-if="tgastos" v-bind:class="{active: tgastos}">
            <v-text-field label="recibos" v-model="gastos" type="number"></v-text-field>
            <v-text-field label="gastos con factura" v-model="gastos_factura" type="number"></v-text-field>
          </div>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" flat="flat" @click.native="dialogcuadrar = false">Cancelar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="dialogcuadrar = false, dialogrevision=true" v-if="cuadrado && !caja.id && buscotabulacion">Aceptar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="modificarcuadrado(codigo)" v-if="cuadrado && caja.id && buscotabulacion">Modificar</v-btn>
        </v-card-actions>
      </v-card>
          </v-dialog>
          <v-dialog v-model="dialognuevo" lazy absolute persistent>
            <v-card>
        <v-card-text>
          <v-text-field label="Nombre" v-model="nombreproducto" @keyup="searchproductos" autofocus ref="searchprodi"></v-text-field>
            <ul class="listadoproducto">

            <li v-for="product, key in this.productos2"
                @click="searchproductodialog(product), dialogbusqueda=false, nombreproducto = ''"
                v-bind:tabindex="0">
               {{product.producto}}
            </li>
          </ul>
          <v-text-field label="Cantidad:" v-model="cantidad" type="number"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="green--text darken-1" flat="flat" @click.native="dialognuevo = false">Cancelar</v-btn>
          <v-btn class="green--text darken-1" flat="flat" @click.native="guardaritemdevolucion">guardar</v-btn>
        </v-card-actions>
      </v-card>
          </v-dialog>
          <v-dialog v-model="dialogrevision" lazy absolute persistent>
          <v-card>
            <v-card-title class="red" pt0>
              <v-layout>
                <v-flex xs1>
                  <h6 class="white--text">Revisión</h6>
                </v-flex>
              </v-layout>
              <v-layout>
                <v-flex>
                  <v-text-field label="Codigo" v-model="codigotabulacion" type="number"
                                dark
                                 >
                  </v-text-field>
                  <v-text-field label="Codigo" v-model="codigotabulacion2" v-if="multitabulacion" type="number"
                                dark
                                 >
                  </v-text-field>
                </v-flex>
                <v-flex mt-3>
                   <v-btn  dark  class="print blue darken-4" @click="cuadrar">
                  Buscar</v-btn>
                </v-flex>
                <v-flex mt-3>
                   <v-btn  dark  class="print blue darken-4" @click="activo=!activo" v-if="activo">
                  Cerrar</v-btn>
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text>
              <v-checkbox
              v-model="revision.tres_candados"
                  label='tres candados'
                ></v-checkbox>
              <v-checkbox v-model="revision.llantas_con_aire" label='llantas c/aire' ></v-checkbox>
              <v-checkbox v-model="revision.limpiez_cabina" label='limpieza cabina' ></v-checkbox>
              <v-checkbox v-model="revision.limpieza_frurgon" label='limpieza frurgon' ></v-checkbox>
              <v-checkbox v-model="revision.troquet" label='troquet' ></v-checkbox>
              <v-checkbox v-model="revision.en_buen_estado" label='en buen estado' ></v-checkbox>
              <v-checkbox v-model="revision.lavado" label='lavado' ></v-checkbox>
               <v-text-field label="observaciones" v-model="revision.comentario"></v-text-field>

            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="green--text darken-1" flat="flat" @click.native="dialogrevision = false, dialogcuadrar=!native, native=false">Cancelar</v-btn>
              <v-btn class="green--text darken-1" flat="flat" @click.native="!native?guardarcuadrado(codigo): updateTabulacion()" v-if="cuadrado && !caja.id && buscotabulacion">Guardar</v-btn>
              <v-btn class="green--text darken-1" flat="flat" @click.native="updateTabulacion()" v-if="caja.id">Guardar</v-btn>
            </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-action>
      </v-card>
      <v-layout row justify-center>
  </v-layout>
 </div>
</template>

<script>
import {
  cuadrarrepartourl,
  cuadrarcajareparto,
  revisionurl,
  ubicacioncuadreurl
} from '../plugins/urlsbackend'
export default{
  data () {
    return {
      auto_name: '',
      buscador: '',
      activo: '',
      caja: '',
      codigotabulacion: '',
      multitabulacion: false,
      dialogbusqueda: false,
      buscotabulacion: false,
      dialogcuadrar: false,
      dialognuevo: false,
      dialogrevision: false,
      native: false,
      codigo: '',
      nombreproducto: '',
      cantidad: 1,
      tbilletes: true,
      tmonedas: false,
      totros: false,
      tgastos: false,
      b200: null,
      codigotabulacion2: '',
      gastos: 0,
      gastos_factura: 0,
      b100: 0,
      b50: 0,
      b20: 0,
      b10: 0,
      b5: 0,
      b1: 0,
      m1: 0,
      m50: 0,
      m25: 0,
      m10: 0,
      m5: 0,
      boleta: 0,
      no_boleta: '',
      no_boleta2: '',
      no_boleta3: '',
      observaciones: '',
      cheque: 0,
      deuda: 0,
      revision: {
        tres_candados: false,
        llantas_con_aire: false,
        limpiez_cabina: false,
        limpieza_frurgon: false,
        troquet: false,
        en_buen_estado: false,
        lavado: false
      }
    }
  },
  methods: {
    buscar: function () {
      if (this.multitabulacion) {
        this.$store.dispatch('actualizardevoluciones', {tabulacion: this.codigotabulacion,
          tabulacion2: this.codigotabulacion2})
      } else {
        this.$store.dispatch('actualizardevoluciones', {tabulacion: this.codigotabulacion})
      }
    },
    editardevolucion: function (producto) {
      let r = confirm(' esta seguro que esta cuadrado ' + producto.producto)
      if (r === true) {
        this.$store.commit('eliminardevolucion', producto)
      }
    },
    guardardevolucion: function () {
      this.dialogbusqueda = false
      if (this.multitabulacion) {
        this.$store.dispatch('guardardevolucion', {'codigo': this.codigo, 'productos': this.$store.getters.listadodevoluciones, 'tabulacion': this.codigotabulacion, 'tabulacion2': this.codigotabulacion2})
      } else {
        this.$store.dispatch('guardardevolucion', {'codigo': this.codigo, 'productos': this.$store.getters.listadodevoluciones, 'tabulacion': this.codigotabulacion})
      }
    },
    searchproductos () {
      this.$store.dispatch('buscarproductos', {producto: this.nombreproducto, bodega: 1})
    },
    searchproductodialog (event) {
      if (event.barra) {
        this.$store.dispatch('buscarproducto', {producto: event.barra, bodega: 1})
        this.$store.commit('actualizarproductos', [])
      } else {
        this.$store.dispatch('buscarproducto', {producto: event.codigo, bodega: 1})
        this.$store.commit('actualizarproductos', [])
      }
      this.$refs.cantidad.focus()
    },
    guardaritemdevolucion: function () {
      this.$store.commit('agregardevolucion', {id: this.productoactual.id, producto: this.nombreproducto, total: 0, ingreso: this.cantidad, activo: false})
      this.dialognuevo = false
      this.nombreproducto = ''
      this.cantidad = 1
    },
    activarbilletes: function () {
      this.tbilletes = true
      this.tmonedas = false
      this.totros = false
      this.tgastos = false
    },
    activarmonedas: function () {
      this.tbilletes = false
      this.tmonedas = true
      this.totros = false
      this.tgastos = false
    },
    activarotros: function () {
      this.tbilletes = false
      this.tmonedas = false
      this.tgastos = false
      this.totros = true
    },
    activargastos: function () {
      this.tbilletes = false
      this.tmonedas = false
      this.tgastos = true
      this.totros = false
    },
    cuadrar: function () {
      this.buscotabulacion = true
      if (this.multitabulacion) {
        this.$http.get(cuadrarrepartourl,
          {params: {
            tabulacion: this.codigotabulacion,
            tabulacion2: this.codigotabulacion2
          },
            headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}
              ).then(response => {
                if (response.body.total) {
                  this.deuda = response.body.total
                  this.limpiarcaja()
                } else {
                  this.caja = response.body
                  this.deuda = response.body.total_reparto
                  this.b200 = response.body.b200
                  this.b100 = response.body.b100
                  this.b50 = response.body.b50
                  this.b20 = response.body.b20
                  this.b10 = response.body.b10
                  this.b5 = response.body.b5
                  this.b1 = response.body.b1
                  this.m1 = response.body.m1
                  this.m50 = response.body.m50
                  this.m25 = response.body.m25
                  this.m10 = response.body.m10
                  this.m5 = response.body.m5
                  this.gastos = response.body.otros_gastos
                  this.gastos_factura = response.body.gastos_con_factura
                  this.boleta = response.body.boleta
                  this.no_boleta = response.body.no_boleta
                  this.no_boleta2 = response.body.no_boleta2
                  this.no_boleta3 = response.body.no_boleta3
                  this.observaciones = response.body.observaciones
                  this.calificacion = response.body.calificacion
                  this.cheque = response.body.cheque
                  this.calificacion = response.body.calificacion
                }
              })
      } else {
        this.$http.get(cuadrarrepartourl,
          {params: {
            tabulacion: this.codigotabulacion
          },
            headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}
              ).then(response => {
                if (response.body.total) {
                  this.deuda = response.body.total
                  this.limpiarcaja()
                } else {
                  this.caja = response.body
                  if (this.caja.tabulacion2) {
                    this.codigotabulacion2 = this.caja.tabulacion2
                    this.multitabulacion = true
                  }
                  console.log(response.body)
                  this.deuda = response.body.total_reparto
                  this.b200 = response.body.b200
                  this.b100 = response.body.b100
                  this.b50 = response.body.b50
                  this.b20 = response.body.b20
                  this.b10 = response.body.b10
                  this.b5 = response.body.b5
                  this.b1 = response.body.b1
                  this.m1 = response.body.m1
                  this.m50 = response.body.m50
                  this.m25 = response.body.m25
                  this.m10 = response.body.m10
                  this.m5 = response.body.m5
                  this.gastos = response.body.otros_gastos
                  this.gastos_factura = response.body.gastos_con_factura
                  this.boleta = response.body.boleta
                  this.no_boleta = response.body.no_boleta
                  this.no_boleta2 = response.body.no_boleta2
                  this.no_boleta3 = response.body.no_boleta3
                  this.observaciones = response.body.observaciones
                  this.calificacion = response.body.calificacion
                  this.cheque = response.body.cheque
                  this.inicializarRevision(response.body.revision_data)
                }
                if (response.body.total) {
                  this.inicializarRevision()
                }
              })
      }
    },
    guardarcuadrado: function () {
      let numerotabulacion2 = '0000'
      if (this.multitabulacion) {
        numerotabulacion2 = this.codigotabulacion2
      } else {
        numerotabulacion2 = null
      }
      let datos = {numero_tabulacion: this.codigotabulacion,
        numero_tabulacion2: numerotabulacion2,
        total: this.total,
        revision: this.revision,
        deuda: this.deuda,
        b200: this.b200 ? this.b200 : null,
        b100: this.b100 ? this.b100 : null,
        b50: this.b50 ? this.b50 : null,
        b20: this.b20 ? this.b20 : null,
        b10: this.b10 ? this.b10 : null,
        b5: this.b5 ? this.b5 : null,
        b1: this.b1 ? this.b1 : null,
        m50: this.m50 ? this.m50 : null,
        m25: this.m25 ? this.m25 : null,
        m10: this.m10 ? this.m10 : null,
        m5: this.m5 ? this.m5 : null,
        m1: this.m1 ? this.m1 : null,
        cheque: this.cheque ? this.cheque : null,
        boleta: this.boleta ? this.boleta : null,
        no_boleta: this.no_boleta ? this.no_boleta : null,
        no_boleta2: this.no_boleta2 ? this.no_boleta2 : null,
        no_boleta3: this.no_boleta3 ? this.no_boleta3 : null,
        observaciones: this.observaciones ? this.observaciones : null,
        calificacion: this.calificacion ? this.calificacion : null,
        otros_gastos: this.gastos ? this.gastos : null,
        gastos_factura: this.gastos_factura ? this.gastos_factura : null
      }
      this.$http.post(cuadrarrepartourl, datos, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}
        ).then(async response => {
          alert('cuadrado con existo')
          await this.registrarUbicacionCuadre()
          this.limpiarcaja()
          window.location.href = '/devoluciones'
        }, (response) => {
          alert(response.bodyText)
        })
    },
    inicializarRevision: function (revision = null) {
      this.revision = revision || {
        tres_candados: false,
        llantas_con_aire: false,
        limpiez_cabina: false,
        limpieza_frurgon: false,
        troquet: false,
        en_buen_estado: false,
        lavado: false,
        comentario: ''
      }
    },
    updateTabulacion: function () {
      let metodo = this.revision.id ? 'put' : 'post'
      let url = this.revision.id ? revisionurl + this.revision.id + '/' : revisionurl
      let datos = this.revision
      if (!this.revision.id) {
        datos = Object.assign({}, this.revision, {cuadre: this.caja.id})
      }
      this.$http[metodo](url, datos, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}
        ).then(response => {
          alert('Guardado Exitosamente')
          this.limpiarcaja()
          window.location.href = '/devoluciones'
        }, (response) => {
          console.log(response)
          alert(response.bodyText)
        })
    },
    modificarcuadrado: function () {
      let numerotabulacion2 = '0000'
      if (this.multitabulacion) {
        numerotabulacion2 = this.codigotabulacion2
      } else {
        numerotabulacion2 = null
      }
      let datos = {numero_tabulacion: this.codigotabulacion,
        numero_tabulacion2: numerotabulacion2,
        total: this.total,
        deuda: this.deuda,
        b200: this.b200 ? this.b200 : null,
        b100: this.b100 ? this.b100 : null,
        b50: this.b50 ? this.b50 : null,
        b20: this.b20 ? this.b20 : null,
        b10: this.b10 ? this.b10 : null,
        b5: this.b5 ? this.b5 : null,
        b1: this.b1 ? this.b1 : null,
        m50: this.m50 ? this.m50 : null,
        m25: this.m25 ? this.m25 : null,
        m10: this.m10 ? this.m10 : null,
        m5: this.m5 ? this.m5 : null,
        m1: this.m1 ? this.m1 : null,
        cheque: this.cheque ? this.cheque : null,
        boleta: this.boleta ? this.boleta : null,
        no_boleta: this.no_boleta ? this.no_boleta : null,
        no_boleta2: this.no_boleta2 ? this.no_boleta2 : null,
        no_boleta3: this.no_boleta3 ? this.no_boleta3 : null,
        observaciones: this.observaciones ? this.observaciones : null,
        calificacion: this.calificacion ? this.calificacion : null,
        otros_gastos: this.gastos ? this.gastos : null,
        gastos_factura: this.gastos_factura ? this.gastos_factura : null,
        total_reparto: this.deuda
      }
      this.$http.put(cuadrarcajareparto + this.caja.id + '/', datos, {headers: {'Authorization': 'Token ' + localStorage.getItem('token')}}
        ).then(async response => {
          alert('cuadrado con existo')
          await this.registrarUbicacionCuadre()
          this.limpiarcaja()
          window.location.href = '/devoluciones'
        }, (response) => {
          alert(response.bodyText)
        })
    },
    registrarUbicacionCuadre: function () {
      if (!navigator.geolocation) {
        return Promise.resolve()
      }

      return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition((position) => {
          const tabulacion = this.codigotabulacion || 'sin tabulacion'
          this.$http.post(ubicacioncuadreurl, {
            numero_tabulacion: tabulacion,
            ubicacion: position.coords.latitude + ',' + position.coords.longitude
          }, {
            headers: {'Authorization': 'Token ' + localStorage.getItem('token')}
          }).then(resolve, resolve)
        }, () => {
          console.warn('No se pudo obtener la ubicación del cuadre de reparto.')
          resolve()
        })
      })
    },
    limpiarcaja: function () {
      this.b200 = null
      this.b100 = null
      this.b50 = null
      this.b20 = null
      this.b10 = null
      this.b5 = null
      this.b1 = null
      this.m1 = null
      this.m50 = null
      this.m25 = null
      this.m10 = null
      this.m5 = null
      this.gastos = null
      this.gastos_factura = null
      this.boleta = null
      this.cheque = null
    }
  },
  computed: {
    productos: function () {
      return this.$store.getters.listadodevoluciones.productos
    },
    productos2: function () {
      return this.$store.getters.productos
    },
    productoactual: function () {
      return this.$store.getters.producto
    },
    total: function () {
      return ((parseInt(this.b1 ? this.b1 : 0)) + ((this.b5 ? this.b5 : 0) * 5) + ((this.b10 ? this.b10 : 0) * 10) + ((this.b20 ? this.b20 : 0) * 20) + ((this.b50 ? this.b50 : 0) * 50) +
          ((this.b100 ? this.b100 : 0) * 100) + ((this.b200 ? this.b200 : 0) * 200) + (parseInt(this.m1 ? this.m1 : 0)) + ((this.m50 ? this.m50 : 0) * 0.50) + ((this.m25 ? this.m25 : 0) * 0.25) +
          ((this.m10 ? this.m10 : 0) * 0.10) + ((this.m5 ? this.m5 : 0) * 0.05) + parseFloat(this.cheque ? this.cheque : 0) + parseFloat(this.boleta ? this.boleta : 0) + parseFloat(this.gastos ? this.gastos : 0) + parseFloat(this.gastos_factura ? this.gastos_factura : 0)).toFixed(2)
    },
    faltante: function () {
      return (this.deuda - this.total).toFixed(2)
    },
    cuadrado: function () {
      if (this.faltante <= 0 && this.total >= 0 && this.buscotabulacion) {
        return true
      }
    }
  },
  watch: {
    productoactual: function (e) {
      this.nombreproducto = e.producto
    }
  }
}
</script>

<style>
  .content_tabulacion {
    display: flex;
    justify-content: space-between;
    background: #03a9f4;
    color: white;
    cursor: pointer;
  }
  .tabulacion {
    background-color: #03a9f4;
    transition: background-color 1s;
  }
  .tabulacion:hover {
    background-color: rgba(0,0,0,0.20);
  }
  .detallebilletes, .detallemonedas, .detalleotros , .detallegastos{
    position: relative;
    height: 0;
    transition: height 4s, background-color 2s;
    background-color: white;
  }
  .active {
    position: relative;
    height: 100%;
  }
  .progreso {
    background: black;
  }
  .totales{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: lightblue;
  }
  .totales p {
    font-size: 15px;
  }
  .totales p:first-child {
    color: red;
    font-size: 15px;
  }

</style>



// WEBPACK FOOTER //
// ReporteDevolucion.vue?b6290b62